import { ApiError } from '@/shared/api/ApiError';
import { httpClient } from '@/shared/api/httpClient';

import { demoPersonasResponseSchema } from '../model/types';
import type { DemoPersonasResponse } from '../model/types';

/**
 * Sonda i treść paska w jednym wywołaniu.
 *
 * `null` = „to nie jest tenant demo" (404) — poprawny wynik u każdego klienta,
 * nie awaria. Prawdziwe awarie (sieć, 5xx) też schodzą do `null`: pasek jest
 * warstwą demo, więc jego brak niczego w produkcie nie psuje, a zwykłe logowanie
 * dalej działa. ⛔ Rozróżniania „nie-demo" od „demo z awarią" świadomie nie ma —
 * wymagałoby drugiego źródła prawdy o tym, czym jest tenant.
 */
export async function fetchDemoPersonas(signal?: AbortSignal): Promise<DemoPersonasResponse | null> {
  try {
    const response = await httpClient.get<unknown>('/demo/personas', {
      ...(signal ? { signal } : {}),
      anonymous: true,
    });

    return demoPersonasResponseSchema.parse(response);
  } catch (error) {
    if (error instanceof ApiError) {
      return null;
    }

    throw error;
  }
}
